import promiseMiddleware from "redux-promise-middleware";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";
import { connectRouter } from "connected-react-router";
import rootReducer from "./reducers";
const history = createBrowserHistory();
const isDev = true;

const middleware = applyMiddleware(promiseMiddleware, thunk);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  connectRouter(history)(rootReducer),
  isDev ? composeEnhancers(middleware) : middleware
);

export default store;
